import {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

export const useExpandedFaq = () => {
  const [expandedId, setExpandedId] = useState<string | null>(null);

  const [searchParams] = useSearchParams();
  const q = searchParams.get('q') || '';

  const handledExpandedId = (id: string) => {
    if (expandedId === id) {
      setExpandedId(null);
    } else {
      setExpandedId(id);
    }
  };

  useEffect(() => {
    // 키워드 바뀔 때 펼쳐진 아이템 접기
    if (q) {
      setExpandedId(null);
    }
  }, [q]);

  return {expandedId, setExpandedId: handledExpandedId};
};
